import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthserviceService} from '../content/pages-new-design/auth-page/login-page/authservice.service';
import {Observable} from 'rxjs/internal/Observable';

@Injectable()
export class AuthGuardService  {

  constructor(
    private authService: AuthserviceService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const authenticated = this.authService.isAuthenticated();

    if (authenticated === false) {
      this.router.navigate(['']);
    }

    return authenticated;
  }

}
